import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Button, ButtonLink } from '@blueprint/ui';
import { ButtonActionProps } from './Buttons.types';

export const StyledButton = styled(ButtonLink)(
    ({ theme: { spacing } }) => css`
        svg {
            margin-right: ${spacing['8px']};
        }
    `
);

export const StyledButtonCall = styled(StyledButton)();
export const StyledButtonEmail = styled(StyledButton)();

export const StyledButtonAction = styled(Button)<ButtonActionProps>((props) => {
    const {
        isCollapsible,
        isTranslucent,
        theme: { mq, spacing, colors }
    } = props;

    const uncollapsedStyles = css`
        width: auto;
        height: auto;
        padding: 0.75rem ${spacing['24px']};

        svg {
            margin-right: ${spacing['8px']};
        }

        span {
            display: inline-block;
            text-align: left;
        }
    `;

    return css`
        width: 2.75rem;
        height: 2.75rem;
        padding: 0;
        min-width: 0;

        svg {
            margin: 0;
        }

        span {
            display: none;
        }

        ${!isCollapsible && uncollapsedStyles};

        ${mq.medium} {
            ${uncollapsedStyles};
        }

        ${isTranslucent &&
        `
                background: ${colors['white-opacity80']};
                border: none;
            `};
    `;
});

export const StyledButtonShare = styled(StyledButtonAction)();

export const StyledButtonSave = styled(StyledButtonAction)(`
    span {
        min-width: 2.7rem;
    }
`);

export const StyledButtonText = styled(Button)(
    ({ theme: { spacing, type } }) => `
    padding: ${spacing['4px']} ${spacing['8px']};
    line-height: ${type['lineHeight']};
`
);
